<router-outlet></router-outlet>

<x-loading></x-loading>
